import React from 'react';
import { linkifyText, Spacer } from 'src/common';
import { Label, Wrap } from './tableSheets.styles';
import { ControlFrameworkDetailsQuery } from 'src/graphql/_generated';

type ControlLibraryItem = ControlFrameworkDetailsQuery['controlFrameworks'][number]['frameworkControls'][number];

interface TableSheetControlLibraryProps {
  data: ControlLibraryItem;
}

export const TableSheetControlLibrary: React.FC<TableSheetControlLibraryProps> = ({ data }) => {
  return (
    <Wrap>
      <div className="grid grid--2">
        <div>
          <Label>NAME</Label>
          <div className="value" data-cy="sheet-name">
            {data.name}
          </div>
        </div>
        <div>
          <Label>Short Name</Label>
          <div className="value">{data.shortname}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <div>
        <Label>Framework</Label>
        <div className="value">{data.controlFramework?.shortname}</div>
      </div>

      <Spacer $px={10} />
      <div className="grid grid--3">
        <div>
          <Label>Framework Control ID</Label>
          <div className="value">{data.control_identifier}</div>
        </div>
        <div>
          <Label>Strategy</Label>
          <div className="value">{data.strategy}</div>
        </div>
        <div>
          <Label>Author</Label>
          <div className="value">{data.controlFramework?.author}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <Label>DESCRIPTION</Label>
      <div className="value">
        {data.controlFramework?.description ? linkifyText(data.controlFramework.description) : null}
      </div>
    </Wrap>
  );
};
